import { render, staticRenderFns } from "./MobileHeaderTabs.vue?vue&type=template&id=6197aa99&scoped=true&"
import script from "./MobileHeaderTabs.vue?vue&type=script&lang=js&"
export * from "./MobileHeaderTabs.vue?vue&type=script&lang=js&"
import style0 from "./MobileHeaderTabs.vue?vue&type=style&index=0&id=6197aa99&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6197aa99",
  null
  
)

export default component.exports